import { useState } from "react";
import { toast } from "sonner";
import { Mic2 } from "lucide-react";
import { endpoints } from "@/lib/api";
import { PageHeader, Card, Field, Btn, DeleteBtn, Loading, Empty, useCrud, handleErr } from "./AdminUI";

const BLANK = { name: "", host: "", description: "" };

export default function AdminPrograms() {
  const { data: programs, loading, reload } = useCrud(endpoints.adminPrograms);
  const [form, setForm] = useState(BLANK);

  const create = async () => {
    if (!form.name) { toast.error("Name required"); return; }
    try { await endpoints.adminCreateProgram(form); toast.success("Program added"); setForm(BLANK); reload(); }
    catch (e) { handleErr(e); }
  };
  const del = async (id) => { try { await endpoints.adminDeleteProgram(id); toast.success("Deleted"); reload(); } catch (e) { handleErr(e); } };

  return (
    <div>
      <PageHeader title="Programs" desc="Regular shows and their hosts." />
      <Card className="p-5 mb-6 grid sm:grid-cols-4 gap-3 items-end">
        <Field label="Program name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="program-name-input" />
        <Field label="Host" value={form.host} onChange={(e) => setForm({ ...form, host: e.target.value })} />
        <Field label="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
        <Btn onClick={create} data-testid="program-add-btn"><Mic2 className="w-4 h-4" /> Add</Btn>
      </Card>
      {loading ? <Loading /> : programs.length === 0 ? <Empty /> : (
        <div className="grid sm:grid-cols-2 gap-4">
          {programs.map((p) => (
            <Card key={p.id} data-testid={`admin-program-${p.id}`} className="p-5 flex items-start justify-between gap-3">
              <div><div className="text-white font-semibold">{p.name}</div>{p.host && <div className="text-xs text-slate-400">Host: {p.host}</div>}{p.description && <p className="text-sm text-slate-400 mt-2">{p.description}</p>}</div>
              <DeleteBtn onClick={() => del(p.id)} testid={`program-delete-${p.id}`} />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
